export const READ_MESSAGES = 'CHAT/READ_MESSAGES_REQUEST';
export const READ_MESSAGES_SUCCESS = 'CHAT/READ_MESSAGES_SUCCESS';
export const READ_MESSAGES_FAILURE = 'CHAT/READ_MESSAGES_FAILURE';

export const SEND_MESSAGE = 'CHAT/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'CHAT/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'CHAT/SEND_MESSAGE_FAILURE';

export const FETCH_MESSAGES = 'CHAT/FETCH_MESSAGES';
export const FETCH_MESSAGES_SUCCESS = 'CHAT/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'CHAT/FETCH_MESSAGES_FAILURE';

export const FETCH_NEXT_MESSAGES = 'CHAT/FETCH_NEXT_MESSAGES';
export const FETCH_NEXT_MESSAGES_SUCCESS = 'CHAT/FETCH_NEXT_MESSAGES_SUCCESS';
export const FETCH_NEXT_MESSAGES_FAILURE = 'CHAT/FETCH_NEXT_MESSAGES_FAILURE';
